import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
})
export class InputTextComponent implements OnInit {
  @Input() inputId: string;
  @Input() label: string;
  @Input() isInvalid = false;
  @Input() isDisabled = false;
  @Input() required = false;
  @Input() optionalTag = true;
  @Input() autocomplete = 'off';
  @Input() control: any;
  @Input() maxLength: number = 524288; // HTML5 max length
  @Input() trim = 'blur';
  @Input() errorText: string;
  @Input() inputType: string = 'text';
  @Input() placeholder: string = '';
  @Output() keyupEvent = new EventEmitter<KeyboardEvent>();
  @Output() changeEvent = new EventEmitter<Event>();
  @Output() blurEvent = new EventEmitter<Event>();
  @Output() focusoutEvent = new EventEmitter<Event>();

  ngOnInit() {
    if (!this.inputId) {
      this.inputId = this.generateRandomId();
    }
  }

  generateRandomId(): string {
    return 'id-' + Math.random().toString(36).substring(2, 11);
  }

  onKeyup(event: KeyboardEvent) {
    this.keyupEvent.emit(event);
  }

  onChange(event: Event) {
    this.changeEvent.emit(event);
  }

  onBlur(event: Event) {
    this.blurEvent.emit(event);
  }

  onFocusout(event: Event) {
    this.focusoutEvent.emit(event);
  }
}
